import React from 'react';

import Image from 'next/image';

import Layout from '@/modules/core/components/Layout';
import Text from '@/tayara-kit/Text';

// @ts-ignore
const GameResultsPage = () => (
  <>
    <div className="w-full absolute overflow-hidden overscroll-none lg:md:top-[4rem] md:top-[3rem] top-[2.5rem] right-2  flex justify-between ">
      <Image
        width={176}
        height={157}
        src="/media/Fichier 4.svg"
        alt="Tayara logo Célébration"
        className="-z50 lg:w-[35rem] md:w-[20rem] w-[55rem] justify-start md:rotate-[-6deg] rotate-[0deg] "
      />
      <Image
        width={176}
        height={157}
        src="/media/Fichier 3.svg"
        alt="Tayara logo Célébration"
        className="-z50 lg:w-[35rem] md:w-[20rem]   justify-end rotate-12 "
      />
    </div>
    <div className="container flex-col justify-center items-center w-full mx-auto mt-20  ">
      {/* Habillage World Cup Left and Right sides  */}
      <div className="flex w-full justify-between ">
        {/* Left Side Elements */}
        <div className=" justify-items-start">
          <Image
            width={176}
            height={157}
            src="/media/cadeau.png"
            alt="tunisia ball"
            className="-z-50 lg:w-[3rem] md:w-[4rem] w-[2rem] absolute  left-[20rem] blur-[2px] lg:top-[15rem] md:top-[25rem] top-[620rem] "
          />

          <Image
            width={176}
            height={157}
            src="/media/Fichier 2.png"
            alt=""
            className="absolute -z-50 lg:w-[15rem] md:w-[15rem] w-[10rem]  top-[5rem] md:top-[5rem] lg:left-[-5rem] md:left-[-5rem] left-[-2rem] rotate-[120deg]  "
          />

          <Image
            width={176}
            height={157}
            src="/media/cadeau.png"
            alt="tunisia ball"
            className="-z-50 lg:w-[6rem] md:w-[4rem] w-[2rem] absolute  top-[8rem] lg:md:top-[30rem] md:top-[30rem] lg:left-[10rem] md:left-[10rem] left-[6rem] rotate-45  "
          />
          <Image
            width={176}
            height={157}
            src="/media/Fichier 2.png"
            alt=""
            className="absolute -z-50 lg:w-[20rem] md:w-[15rem] w-[10rem] lg:top-[38rem] md:top-[30rem] top-[5rem] lg:right-[10px] md:right-[3px] right-[4px] blur-[0.5px] rotate-[-90deg] "
          />
          <Image
            width={176}
            height={157}
            src="/media/Fichier 2.png"
            alt=""
            className="absolute -z-50 lg:w-[20rem] md:w-[4rem] w-[10rem]   lg:top-[38 rem] md:top-[30rem] top-[20rem] lg:left-[-5rem] md:left-[-5rem] left-[-55rem] rotate-45 "
          />
        </div>

        {/* Right side elements */}

        <div className="  justify-items-end">
          <Image
            width={176}
            height={157}
            src="/media/cadeau.png"
            alt="tunisia ball"
            className="-z-50 lg:w-[6rem] md:w-[4rem] w-[2rem] lg:top-[40rem] md:top-[30rem] top-[8rem]  lg:right-[10rem] md:right-[10rem] right-[8rem]  absolute rotate-[-30deg]  "
          />
          <Image
            width={176}
            height={157}
            src="/media/cadeau.png"
            alt="tunisia ball"
            className="-z-50 lg:w-[3rem] md:w-[4rem] w-[2rem] absolute right-[20rem] md:right-[10rem] blur-[2px] lg:top-[15rem] md:top-[15rem] top-[45rem] "
          />
          <Image
            width={176}
            height={157}
            src="/media/cadeau.png"
            alt="tunisia ball"
            className="-z-50 lg:w-[3rem] md:w-[4rem] w-[2rem] absolute lg:right-[20rem] md:right-[20rem] right-[2rem] blur-[2px] lg:top-[50rem] md:top-[50rem] top-[47rem] "
          />
        </div>
      </div>
    </div>

    <div className="w-full h-fit flex flex-col mt-4 justify-items-center">
      <Text
        as="h1"
        text="  LISTE DES GAGNANTS"
        dir="auto"
        className="text-gray-800 font-bold text-2xl md:text-3xl font-arabic text-center mt-10 "
      />
      <Text
        as="h1"
        text="  Tirage au sort du 19/12/2022"
        dir="auto"
        className="text-gray-800 font-normal text-l md:text-xl font-arabic text-center mt-2  mb-6"
      />
      <Image
        width={1000}
        height={800}
        src="/media/secondGameResults.png"
        alt="Deuxième Résultats du jeu de Tayara"
        className="self-center mx-auto max-w-[400px] lg:max-w-[700px] mt-4  w-full"
      />
    </div>
  </>
);

export default GameResultsPage;

// Dynamic layout configuration
GameResultsPage.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};
